import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
import { REGIONS } from "@/lib/locations";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const RussianLocationsPage = () => {
  return (
    <div className="flex min-h-screen flex-col" lang="ru">
      <SEO 
        title="Зоны обслуживания | Uplevel Cleaning"
        description="Мы обслуживаем Сакраменто, Лос-Анджелес, Залив Сан-Франциско, Сан-Диего и Округ Ориндж. Найдите свой город!"
        keywords="зоны обслуживания уборка, клининг калифорния"
        url="https://uplevelcleaning.com/ru/locations"
        alternateUrl="https://uplevelcleaning.com/locations"
        alternateLang="en-US"
        lang="ru"
      />
      <Navbar />
      <main className="flex-1 pt-32 pb-24 bg-muted/10">
        <div className="container max-w-6xl">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">Наши зоны обслуживания</h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Мы предоставляем первоклассные услуги по уборке домов по всей Калифорнии. Выберите свой регион ниже.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {Object.entries(REGIONS).map(([regionSlug, region]) => (
              <div key={regionSlug} className="bg-background rounded-2xl border shadow-sm overflow-hidden flex flex-col">
                <div className="bg-primary/10 p-6 border-b">
                  <h2 className="text-2xl font-bold text-primary flex items-center gap-2">
                    <MapPin className="h-6 w-6" /> {region.name}
                  </h2>
                </div>
                <div className="p-6 flex-1">
                  <ul className="grid grid-cols-2 gap-3 mb-8">
                    {region.cities.map(city => (
                      <li key={city}>
                        <Link 
                          to={`/ru/${city.toLowerCase().replace(/\s+/g, '-')}`}
                          className="text-muted-foreground hover:text-primary transition-colors text-sm flex items-center gap-1"
                        >
                          <ArrowRight className="h-3 w-3" /> {city}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="p-6 pt-0 mt-auto">
                  <Button asChild className="w-full" variant="outline">
                    <Link to={`/ru/${region.cities[0].toLowerCase().replace(/\s+/g, '-')}`}>
                      Услуги в {region.name}
                    </Link>
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default RussianLocationsPage;
